export default "__VITE_ASSET__ppD$JxXw__"